import hasDateAsTimestampInJson from './hasDateAndTimestampInJson';

export default hasDateAsTimestampInJson;
